var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1822 4.81805C13.9395 6.57541 13.9395 9.42466 12.1822 11.182M5.81819 11.182C4.06083 9.42466 4.06083 6.57541 5.81819 4.81805M3.6967 13.3034C0.767767 10.3744 0.767767 5.62571 3.6967 2.69678M14.3036 2.69678C17.2326 5.62571 17.2326 10.3744 14.3036 13.3034M9.00017 9.50006C9.82859 9.50006 10.5002 8.82849 10.5002 8.00006C10.5002 7.17163 9.82859 6.50006 9.00017 6.50006C8.17174 6.50006 7.50017 7.17163 7.50017 8.00006C7.50017 8.82849 8.17174 9.50006 9.00017 9.50006ZM9.00017 9.50006V16.2501",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal);
export default __webpack_public_path__ + "static/media/signal.5905a17739300f7bf12dbb5b21dc6df4.svg";
export { ForwardRef as ReactComponent };